export default {
    namespaced: true,
    state: {
        cookies: false,
    },
    actions: {
        acceptCookies(context) {
            context.commit('ACCEPT_COOKIES')
        },
    },
    mutations: {
        ACCEPT_COOKIES(state) {
            state.cookies = true
        },
    },
}
